<div class="app-dialog merge-orders-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ "printCardOrders.merge.title" | translate }}</h2>
      <p class="app-dialog__subtitle">
        {{ "printCardOrders.merge.subtitle" | translate }}
      </p>
    </div>
    <button
      mat-icon-button
      type="button"
      (click)="close()"
      [attr.aria-label]="'cancel' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body merge-orders-dialog__body">
    <div class="merge-orders-dialog__loading" *ngIf="loading">
      <app-loading></app-loading>
    </div>

    <div class="merge-orders-dialog__empty" *ngIf="!loading && orders.length === 0">
      <mat-icon>merge_type</mat-icon>
      <p>{{ "printCardOrders.merge.empty" | translate }}</p>
    </div>

    <div class="merge-orders-dialog__list" *ngIf="!loading && orders.length > 0">
      <div
        class="merge-order-row"
        *ngFor="let order of orders"
        [class.merge-order-row--selected]="isSelected(order.printCardOrderId)"
        [class.merge-order-row--primary]="isPrimaryOffer(order.printCardOrderId)"
        (click)="toggleOrder(order)"
      >
        <mat-checkbox
          color="primary"
          [checked]="isSelected(order.printCardOrderId)"
          (click)="$event.stopPropagation()"
          (change)="setSelected(order, $event.checked)"
        ></mat-checkbox>
        <div class="merge-order-row__content">
          <div class="merge-order-row__top">
            <span class="merge-order-row__domain">{{ order.domain }}</span>
            <span class="stage-badge" [attr.data-stage]="order.status">
              {{ getFulfillmentStageLabelKey(order.status) | translate }}
            </span>
          </div>
          <div class="merge-order-row__meta">
            <span>{{ order.createdAt | localizedDate : "short" }}</span>
            <span>{{ orderItemsSummary(order) }}</span>
          </div>
          <div class="merge-order-row__people">
            <span *ngIf="order.recipients?.length > 1">
              {{
                "printCardOrders.groupRecipientsCount"
                  | translate : { count: order.recipients.length }
              }}
            </span>
            <span *ngIf="order.recipients?.length <= 1">
              {{ order.employeeName || order.employeeEmail }}
            </span>
            <span class="merge-order-row__id">{{ order.printCardOrderId }}</span>
          </div>
        </div>
        <button
          type="button"
          class="primary-offer-btn"
          *ngIf="isSelected(order.printCardOrderId)"
          [class.primary-offer-btn--active]="isPrimaryOffer(order.printCardOrderId)"
          (click)="setPrimaryOffer(order.printCardOrderId, $event)"
        >
          <mat-icon>{{
            isPrimaryOffer(order.printCardOrderId) ? "star" : "star_outline"
          }}</mat-icon>
          {{
            (isPrimaryOffer(order.printCardOrderId)
              ? "printCardOrders.merge.primaryOffer"
              : "printCardOrders.merge.setPrimaryOffer"
            ) | translate
          }}
        </button>
      </div>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()" [disabled]="submitting">
      {{ "cancel" | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="submit()"
      [disabled]="!canSubmit || submitting || loading"
    >
      <mat-spinner *ngIf="submitting" diameter="20" class="dc-btn-spinner"></mat-spinner>
      <mat-icon *ngIf="!submitting">call_merge</mat-icon>
      {{
        submitting
          ? ("loading" | translate)
          : ("printCardOrders.merge.confirm" | translate)
      }}
    </button>
  </footer>
</div>
